// removed by extract-text-webpack-plugin
module.exports = {"content":"ContactUs__content__1x5aM","parentContainer":"ContactUs__parentContainer__3ASch"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ContactUs/ContactUs.css
// module id = 1489
// module chunks = 0